import React, { useState, useEffect } from 'react';
import FormModal from '../../Modals/FormModal';
import SelectField from '../../Forms/Input/SelectField';
import { useBranch } from '../../../hooks/branches/useBranch';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import { useProductSettlement } from '../../../hooks/settlement/useProductSettlement';

interface GeneralProductSettlementModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GeneralProductSettlementModal: React.FC<GeneralProductSettlementModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [selectedBranch, setSelectedBranch] = useState<number | ''>('');
  const [errors, setErrors] = useState<{ branch?: string }>({});
  const { fetchBranchDropdown, branchDropdown } = useBranch();
  const { form } = useBasePurchase();
  const { handlerSettleGeneral } = useProductSettlement();

  useEffect(() => {
    if (isOpen) {
      fetchBranchDropdown();
      setSelectedBranch('');
      setErrors({});
    }
  }, [isOpen]);

  const handleSettle = async () => {
    const newErrors: { branch?: string } = {};

    if (!selectedBranch) {
      newErrors.branch = 'Debe seleccionar una sucursal';
    }

    if (!form.id) {
      console.error('❌ No hay compra cargada');
      return;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    await handlerSettleGeneral(form.id, Number(selectedBranch));
    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Asentar Productos - General"
      maxWidth="max-w-lg"
    >
      {/* 🔹 Contenedor principal con más altura */}
      <div className="flex flex-col justify-between min-h-[260px]">
        <div className="mb-6 mt-2">
          <SelectField
            label="Sucursal"
            name="branch"
            iconKey="list"
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(Number(e.target.value))}
            options={branchDropdown.map((b) => ({ value: b.id, label: b.name }))}
            required
            error={errors.branch}
          />
        </div>

        <div className="mt-auto flex justify-end pt-6 border-t border-gray-200">
          <button
            type="button"
            onClick={handleSettle}
            className="flex items-center justify-center gap-2 rounded-lg bg-primary px-6 py-2.5 font-medium text-white shadow-md hover:bg-primary/90 transition-all duration-150"
          >
            Asentar Productos
          </button>
        </div>
      </div>
    </FormModal>
  );
};

export default GeneralProductSettlementModal;
